import { createFileRoute } from '@tanstack/react-router'
import { CustomerTripsSection } from '@ufc/domains/trip-planning'

export const Route = createFileRoute('/tracking')({
  component: CustomerTripsSection,
})
